var _style, _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _rect6, _rect7, _rect8, _path4, _ellipse, _path5, _path6, _ellipse2, _path7, _path8, _path9, _rect9, _path10, _path11, _path12, _rect10, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAhsokaHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0ah{fill:#696969;}\r\n\t.st1ah{fill:#938A8C;}\r\n\t.st2ah{fill:#2B2A2A;}\r\n\t.st3ah{fill:#878787;}\r\n\t.st4ah{fill:#2B2B2B;}\r\n\t.st5ah{fill:#6E6E6D;}\r\n\t.st6ah{fill:#1E1E1E;}\r\n\t.st7ah{fill:#888989;}\r\n\t.st8ah{fill:#A9191E;}\r\n\t.st9ah{fill:#717070;}\r\n\t.st10ah{fill:#202020;}\r\n\t.st11ah{fill:#727272;}\r\n\t.st12ah{fill:#818484;}\r\n\t.st13ah{fill:#ADADAD;}\r\n\t.st14ah{fill:#999998;}\r\n\t.st15ah{fill:#9E9E9B;}\r\n\t.st16ah{fill:#9E9E9E;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 94.7,
    className: "st0ah",
    width: 3.4,
    height: 25.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32.1,
    className: "st1ah",
    width: 3.4,
    height: 11.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2ah",
    d: "M27.2,44.3c0-4.4,0-8.8,0-13.2c1,0,2,0,2.9,0c0.4,1.3,0.9,3.7,0.9,6.8c0,2.9-0.5,5.1-0.9,6.4 C29.1,44.3,28.2,44.3,27.2,44.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9.5,
    className: "st3ah",
    width: 2,
    height: 15.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3ah",
    d: "M26.5,11.9c2.4,0,4.7,0,7.1,0c0.2,0.4,1.6,2.8,1.3,6.3c-0.2,2.3-1,3.8-1.3,4.4c-2.3,0-4.7,0-7,0 C26.6,19,26.6,15.4,26.5,11.9z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 17.9459 34.4354)",
    className: "st3ah",
    width: 2,
    height: 15.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3ah",
    d: "M8.5,22.4c-2.4,0-4.7,0-7.1,0C1.2,22-0.2,19.5,0,16.1c0.2-2.3,1-3.8,1.3-4.4c2.3,0,4.7,0,7,0 C8.4,15.3,8.4,18.8,8.5,22.4z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 13.6,
    className: "st4ah",
    width: 9,
    height: 7.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21.2,
    className: "st5ah",
    width: 7.4,
    height: 4.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 10.2,
    className: "st5ah",
    width: 7.1,
    height: 3.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 24.2,
    className: "st6ah",
    width: 8.4,
    height: 93.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7ah",
    d: "M9.7,127.8C9.6,98.6,9.5,69.5,9.4,40.4c0.3-0.8,0.7-2.3,0.7-4.2c0.1-2.3-0.5-4.1-0.7-4.9c0-10.4,0-20.8,0-31.2 c0.4,0.1,2.7,0.5,4.3,3.7c1.2,2.5,1.2,5.2,1.2,6c0,2.3,0,4.2,0,5.5c0,3.3-0.1,4.4,0.2,6c0.3,1.9,0.8,3.4,1.2,4.3c0,29,0,57.9,0,86.9 c0.4,1.2,0.8,2.5,1.2,3.7c0.5-1.3,1-2.6,1.5-3.9c0-29,0-57.9,0-86.9c0.6-1.3,1.2-2.6,1.8-3.9c0-4.2,0-8.3,0-12.5 c0-2.6,0.7-4.7,2.3-6.6c1-1.2,2.2-1.8,3-2.2C26.1,42.7,26,85.3,25.9,128C20.5,127.9,15.1,127.8,9.7,127.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8ah",
    cx: 26.4,
    cy: 57,
    rx: 0.6,
    ry: 2.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9ah",
    d: "M9.7,127.8c-0.6,2-1.2,4.1-1.8,6.1c2.5,1.3,6.4,2.8,11.3,2.5c3.5-0.2,6.4-1.4,8.5-2.5c-0.6-2-1.3-3.9-1.9-5.9 C20.5,127.9,15.1,127.8,9.7,127.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7ah",
    d: "M27.5,162c-2.3,1.1-5.6,2.3-9.8,2.3c-4.1,0-7.5-1.2-9.7-2.4c0-9.2,0-18.3,0-27.5c0-0.2,0-0.4,0-0.6 c2.6,0.7,5.8,1.3,9.5,1.3c4,0,7.5-0.6,10.3-1.3C27.7,143.3,27.6,152.6,27.5,162z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10ah",
    cx: 17.9,
    cy: 149.7,
    rx: 6,
    ry: 9.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6ah",
    d: "M8.2,170.2c-0.1-2.8-0.1-5.5-0.2-8.3c2.6,1,6.1,1.8,10.2,1.8c3.7,0,6.9-0.8,9.3-1.7c0,2.8-0.1,5.7-0.1,8.5 c-3,1.1-6,2.2-9,3.3c-2.3-0.4-4.8-1.1-7.5-2.3C10,171.2,9.1,170.7,8.2,170.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7ah",
    d: "M8.2,170.2c1.3,2.7,2.7,5.4,4,8.1c3.8,0.2,7.6,0.4,11.4,0.6c1.3-2.8,2.6-5.6,3.9-8.5c-2.9,1-6.9,1.9-11.6,1.5 C12.9,171.7,10.3,171,8.2,170.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7ah",
    d: "M11,196.4c0.9,1.1,3.4,3.6,6.9,3.6c3.4,0,5.7-2.5,6.7-3.6c0-2.3,0-4.5,0-6.8c-4.5,0-9,0-13.5,0.1 C11,191.9,11,194.2,11,196.4z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 185.1,
    className: "st11ah",
    width: 12.8,
    height: 9.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7ah",
    d: "M9.7,183.9c-0.1-1.5-0.2-3-0.3-4.4c0.7-0.9,1.3-1.7,2-2.6c1.5,0.6,3.6,1.2,6.2,1.1c2.7-0.1,5-0.9,6.6-1.7 c1.1,1.6,2.1,3.2,3.2,4.8c-0.7,2-1.5,3.9-2.2,5.9c-2.8-0.2-5.6-0.2-8.6-0.1c-1.9,0.1-3.8,0.2-5.6,0.3C10.5,186,10.1,185,9.7,183.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12ah",
    d: "M28.4,184.3c0-1.3,0-2.5,0-3.8c-0.6,0-1.3,0.1-1.9,0.1c0,1.1,0,2.2-0.1,3.3C27.1,184.1,27.8,184.2,28.4,184.3z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12ah",
    d: "M7.7,180.6c0,1.2,0,2.5,0.1,3.7c0.6-0.3,1.2-0.6,1.9-0.9c0-1-0.1-2.1-0.1-3.1C8.9,180.4,8.3,180.5,7.7,180.6z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 187.8,
    className: "st13ah",
    width: 4.3,
    height: 7.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14ah",
    d: "M23.8,192.3c0-2.4,0-4.8-0.1-7.2c1.1,0.2,2.1,0.3,3.2,0.5c0,2.3,0,4.6,0,7C25.9,192.5,24.8,192.4,23.8,192.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15ah",
    d: "M28.6,184.2c-0.6,0.6-1.1,1.2-1.7,1.8c0,2.2,0,4.4,0,6.5c0.6-0.6,1.1-1.3,1.7-1.9 C28.6,188.5,28.6,186.4,28.6,184.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13ah",
    d: "M26.3,183c-0.9,0.7-1.7,1.4-2.6,2.1c1.1,0.3,2.1,0.6,3.2,1c0.5-0.6,1.1-1.2,1.6-1.8 C27.8,183.8,27.1,183.4,26.3,183z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14ah",
    d: "M12.3,185.2c0,2.3,0,4.6-0.1,6.9c-1,0-2.1,0-3.1,0c0-2.3-0.1-4.5-0.1-6.8C10.2,185.3,11.2,185.3,12.3,185.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15ah",
    d: "M7.4,190.7c0.6,0.5,1.2,1,1.8,1.5c0-2.1,0-4.3,0-6.4c-0.6-0.4-1.2-0.9-1.8-1.3C7.4,186.5,7.4,188.6,7.4,190.7z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13ah",
    d: "M9.5,183.1c-0.7,0.4-1.4,0.9-2.1,1.3c0.6,0.4,1.2,0.9,1.8,1.3c1.1-0.2,2.1-0.3,3.2-0.5 C11.4,184.5,10.4,183.8,9.5,183.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st16ah",
    d: "M20.7,188.2c-1.8,0-3.7,0-5.5,0c0-0.3,0-0.6,0-0.9c1.8,0,3.6,0,5.5,0C20.7,187.6,20.7,187.9,20.7,188.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3ah",
    d: "M20.8,193.9c-0.2,0.3-0.4,0.7-0.6,1c0-2.3,0-4.5,0-6.8c0.2-0.3,0.4-0.6,0.6-0.9 C20.8,189.5,20.8,191.7,20.8,193.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3ah",
    d: "M15.2,194c0.2,0.3,0.4,0.6,0.6,0.9c0-2.2,0-4.5,0-6.7c-0.2-0.3-0.4-0.6-0.6-0.9C15.3,189.5,15.2,191.8,15.2,194 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhsokaHilt);
export default __webpack_public_path__ + "static/media/ahsoka-hilt.bdfdbeb5.svg";
export { ForwardRef as ReactComponent };